import { Link } from "react-router-dom";

/**
 * Shipment number link for PO/TO shipment board card headers.
 * @param {Object} props
 * @param {number|string} props.orderId Consignment id for the detail route.
 * @param {string} props.name Shipment number.
 * @return {React.ReactElement}
 */
export function ShipmentBoardCardTitle({ orderId, name }) {
  return (
    <Link to={`${orderId}`}>{name}</Link>
  );
}
